import styled from 'styled-components';

export const Container = styled.span`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
`;

export const FONT_SIZE = {
  xs: { fontSize: 12 },
  sm: { fontSize: 14 },
  md: { fontSize: 16 },
  lg: { fontSize: 20 },
  xl: { fontSize: 28 },
  xxl: { fontSize: 36 },
};

const titleCss = {
  fontWeight: 'bold',
  textTransform: 'capitalize',
};

/**
 * @typedef {Object} Variants
 * @property {React.CSSProperties} title
 * @property {React.CSSProperties} sub_title
 * @property {React.CSSProperties} text
 * @property {React.CSSProperties} info
 */

/**
 * @type {Variants}
 */
export const VARIANTS = {
  title: {
    ...titleCss,
    ...FONT_SIZE.xl,
  },
  sub_title: {
    ...titleCss,
    ...FONT_SIZE.lg,
  },
  sub_title_1: {
    ...titleCss,
    ...FONT_SIZE.md,
  },
  text: {
    ...FONT_SIZE.sm,
  },
  info: {
    color: '#444444',
    ...FONT_SIZE.xs,
  },
};
